import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";

const navItems = [
  { id: "dashboard", label: "Core Dashboard",     icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" },
  { id: "customers", label: "Client Registry",    icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" },
  { id: "amc",       label: "AMC Agreements",     icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" },
  { id: "invoices",  label: "Invoices & Billing",  icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" },
  { id: "work-orders", label: "Work Orders", icon: "M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" },
];

export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem('ihrd_sidebar_collapsed') === '1'; } catch { return false; }
  });

  useEffect(() => { try { localStorage.setItem('ihrd_sidebar_collapsed', collapsed ? '1' : '0'); } catch {} }, [collapsed]);

  return (
    <aside style={{
      position: 'sticky',
      top: '1rem',
      alignSelf: 'flex-start',
      width: collapsed ? 72 : 240,
      minWidth: collapsed ? 72 : 240,
      background: "rgba(15,23,42,.5)", borderRight: "1px solid #1e293b",
      padding: "1rem", display: "flex", flexDirection: "column", gap: ".25rem", alignItems: collapsed ? 'center' : 'stretch'
    }}>
      <div style={{ width: '100%', display: 'flex', justifyContent: collapsed ? 'center' : 'space-between', alignItems: 'center' }}>
        {!collapsed && (
          <p style={{ fontSize: ".6rem", color: "#475569", textTransform: "uppercase",
            letterSpacing: ".15em", fontWeight: 700, padding: ".5rem .75rem", marginBottom: ".25rem" }}>
            Modules
          </p>
        )}
        <button onClick={() => setCollapsed(c => !c)} title={collapsed ? 'Expand' : 'Collapse'} style={{
          background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer'
        }}>{collapsed ? '›' : '‹'}</button>
      </div>

      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '.25rem', alignItems: collapsed ? 'center' : 'stretch' }}>
        {navItems.map(item => (
          <NavLink key={item.id} to={item.id === 'dashboard' ? '/dashboard' : `/${item.id}`} style={({ isActive }) => ({
            width: '100%', display: 'flex', alignItems: 'center', gap: '.75rem',
            padding: '.625rem .75rem', borderRadius: '.5rem', textDecoration: 'none',
            textAlign: 'left', fontSize: '.875rem', fontWeight: 500, transition: 'all .15s',
            background: isActive ? 'rgba(30,41,59,.6)' : 'transparent',
            color: isActive ? '#22d3ee' : '#64748b', borderLeft: isActive ? '2px solid #06b6d4' : '2px solid transparent',
            justifyContent: collapsed ? 'center' : 'flex-start'
          })}>
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d={item.icon} />
            </svg>
            {!collapsed && item.label}
          </NavLink>
        ))}
      </div>
    </aside>
  );
}
